import { createFileRoute } from '@tanstack/react-router';
import { GeneralError } from '@/features/errors/general-error';

export const Route = createFileRoute('/(errors)/500')({
    head: () => ({ meta: [{ title: 'Server error | promote.fun' }] }),
    component: GeneralError,
});
